module.exports = __webpack_public_path__ + "static/media/examination.a9f25b6c.svg";